import { memo } from 'react';
import { useAtomValue } from 'jotai';
import { isOtpVerificationModalOpen } from '../../context/auth-flow';
import { VerifyOtpForm, VerifyOtpHeader } from './verify-otp-form';

export const VerifyOTPModal = memo(() => {
  const open = useAtomValue(isOtpVerificationModalOpen);
  if (open) {
    return (
      <div className="flex flex-col gap-8 w-full mt-5">
        <VerifyOtpHeader {...{ isModal: true }} />
        <VerifyOtpForm {...{ isModal: true }} />
      </div>
    );
  }
  return undefined;
});
